import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DetailsIcon from '@/svg-icons/details';

function ConstructionDetailsSection({ data }) {
  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <DetailsIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="construction_details" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-work-week">
          <div className="font-bold">
            <FormattedMessage id="work_week" />
          </div>
          {data.work_week || '----'}
        </div>

        <div className="w-1/2 mb-[1vw]" data-cy="order-details-opening-forecast-date">
          <div className="font-bold">
            <FormattedMessage id="opening_forecast_date" />
          </div>
          {data.opening_forecast_date || '----'}
        </div>

        <div className="w-full mb-[1vw]" data-cy="order-details-work-completion-at-sixty">
          <div className="font-bold">
            <FormattedMessage id="work_completion_at_sixty" />
          </div>
          {data.work_completion_at_sixty || '----'}
        </div>
      </div>
    </div>
  );
}

ConstructionDetailsSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ConstructionDetailsSection;
